export enum DetalheVeiculoTypes {
  'LOAD_REQUEST' = '@detalheVeiculo/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@detalheVeiculo/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@detalheVeiculo/LOAD_FAILURE',

  'CLEAN_MOVIENTRADA' = '@detalheVeiculo/CLEAN_MOVIENTRADA',
}

export interface IDetalheVeiculo {
  codVeiculo: number;
  placa: string;
  ano: number;
  codParcTransp: number;
  nomeTipoVeiculo: string;
  nomeTransportadora: string;
}

export interface DetalheVeiculoState {
  readonly data: IDetalheVeiculo[];
  readonly loading: boolean;
  readonly error: boolean;
}
